import Text from '../../Text';
import { CheckboxProps } from './types';
import { Checkmark } from '../icons/Checkmark';

export const Checkbox = ({
  checked,
  id,
  labelText,
  name,
  onChange = () => {},
  type = 'checkbox',
  ...rest
}: CheckboxProps) => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div className="border border-b min-w-[13px] min-h-[13px]" {...rest}>
      <Text
        as="label"
        className="relative cursor-pointer select-none pointer-events-auto flex items-center justify-center w-[13px] h-[13px] "
        html-for={id}
        aria-label={labelText}
        data-qa="select-box"
      >
        {labelText && (
          <Text as="span" ellipsis className=" pl-4 pb-0 leading-[12px]">
            {labelText || ''}
          </Text>
        )}
        <input
          name={name}
          id={id}
          type={type}
          checked={checked}
          onChange={onChange}
          className="peer absolute opacity-0 cursor-pointer left-0"
        />
        {type === 'radio' && (
          <span className="absolute border-solid border cursor-pointer h-3 w-3 top-[2px] left-0 peer-checked:bg-black" />
        )}
        {type === 'checkbox' && checked && <Checkmark />}
      </Text>
    </div>
  );
};
